import React, {useState} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
  Alert,
  Tabs,
  Tab,
} from "react-bootstrap";
import {FaWhatsapp, FaSave, FaKey, FaPhone, FaBuilding} from "react-icons/fa";

const Settings = () => {
  // Estado para manejar los valores del formulario
  const [apiToken, setApiToken] = useState("");
  const [phoneId, setPhoneId] = useState("");
  const [accountId, setAccountId] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSave = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para guardar la configuración en el backend
    console.log("Configuración guardada:", {apiToken, phoneId, accountId});
    setShowSuccess(true);
    // Ocultar el mensaje después de 3 segundos
    setTimeout(() => setShowSuccess(false), 3000);
  };

  return (
    <Container fluid>
      <Row>
        <Col lg={8}>
          <Tabs defaultActiveKey="whatsapp" id="settings-tabs" className="mb-3">
            <Tab
              eventKey="whatsapp"
              title={
                <span>
                  <FaWhatsapp className="me-2" /> WhatsApp API
                </span>
              }
            >
              <Card>
                <Card.Header>Credenciales de WhatsApp Business API</Card.Header>
                <Card.Body>
                  {showSuccess && (
                    <Alert
                      variant="success"
                      onClose={() => setShowSuccess(false)}
                      dismissible
                    >
                      ¡Configuración guardada correctamente!
                    </Alert>
                  )}
                  <Form onSubmit={handleSave}>
                    <Form.Group className="mb-3" controlId="apiToken">
                      <Form.Label>Token de Acceso Permanente</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FaKey />
                        </InputGroup.Text>
                        <Form.Control
                          type="password"
                          value={apiToken}
                          onChange={(e) => setApiToken(e.target.value)}
                          placeholder="Ingresa tu token de acceso"
                          required
                        />
                      </InputGroup>
                      <Form.Text className="text-muted">
                        Tu token de acceso de la API de Meta.
                      </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="phoneId">
                      <Form.Label>ID del Número de Teléfono</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FaPhone />
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          value={phoneId}
                          onChange={(e) => setPhoneId(e.target.value)}
                          placeholder="ID del número de teléfono"
                          required
                        />
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="accountId">
                      <Form.Label>
                        ID de la Cuenta de WhatsApp Business
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FaBuilding />
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          value={accountId}
                          onChange={(e) => setAccountId(e.target.value)}
                          placeholder="ID de la cuenta de WABA"
                          required
                        />
                      </InputGroup>
                    </Form.Group>

                    <Button variant="primary" type="submit">
                      <FaSave className="me-2" />
                      Guardar y Validar
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </Container>
  );
};

export default Settings;
